import {
  Color,
  DisplayMode,
  Engine,
  FadeInOut,
  SolverStrategy,
} from "excalibur";
import { loader } from "./resources";
import { MyLevel } from "./level";
import { Constants } from "./const";

// Goal is to keep main.ts small and just enough to configure the engine

const game = new Engine({
  width: Constants.GameWidth, // Logical width and height in game pixels
  height: Constants.GameHeight,
  displayMode: DisplayMode.FitContainerAndFill, // Display mode tells excalibur how to fill the window
  pixelArt: true, // pixelArt will turn on the correct settings to render pixel art without jaggies or shimmering artifacts
  scenes: {
    start: MyLevel,
  },
  backgroundColor: Color.fromHex("fee1ba"),
  canvasElementId: "game",
  physics: {
    continuous: {
      checkForFastBodies: true,
      disableMinimumSpeedForFastBody: true,
    },
    solver: SolverStrategy.Arcade,
    substep: 20, // Increase substeps for better collision detection with fast-moving objects
  },
  // fixedUpdateTimestep: 16 // Turn on fixed update timestep when consistent physic simulation is important
});

function start() {
  // Make game section fullscreen and blocking
  const gameSection = document.getElementById("game-section")!;
  gameSection.style.position = "fixed";
  gameSection.style.top = "0";
  gameSection.style.left = "0";
  gameSection.style.width = "100%";
  gameSection.style.height = "100%";
  gameSection.style.zIndex = "9999";

  game
    .start("start", {
      // name of the start scene 'start'
      loader, // Optional loader (but needed for loading images/sounds)
      inTransition: new FadeInOut({
        // Optional in transition
        duration: 1000,
        direction: "in",
        color: Color.fromHex("#fee1ba"),
      }),
    })
    .then(() => {});
  // game.toggleDebug();
}

export function showPost(title: string, content: string) {
  // Reset game section positioning when game ends
  const gameSection = document.getElementById("game-section")!;
  gameSection.style.position = "";
  gameSection.style.top = "";
  gameSection.style.left = "";
  gameSection.style.width = "";
  gameSection.style.height = "";
  gameSection.style.zIndex = "";

  // Scroll back to the game section
  gameSection.scrollIntoView({ behavior: "instant", block: "start" });

  document.getElementById("post-game-content")!.innerHTML = content;
  document.getElementById("post-game-title")!.innerText = title;
  const postScreen = document.getElementById("post-game")!;
  postScreen.style.display = "block";

  // Enable clicks after fade-in animation completes (800ms)
  setTimeout(() => {
    postScreen.classList.add("clickable");
  }, 800);
}

window.onload = () => {
  document.getElementsByTagName("body")[0].onkeydown = (e) => {
    if (e.key === " ") {
      e.preventDefault(); // Prevent scrolling when space is pressed
    }
  };

  // Prevent double-tap zoom on game section
  const gameSection = document.getElementById("game-section")!;
  let lastTouchEnd = 0;
  gameSection.addEventListener(
    "touchend",
    (e) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        e.preventDefault();
      }
      lastTouchEnd = now;
    },
    false,
  );

  document.getElementById("start-button")!.onclick = () => {
    const introScreen = document.getElementById("game-intro")!;
    introScreen.style.display = "none";
    start();
  };

  document.getElementById("try-again-button")!.onclick = () => {
    const postScreen = document.getElementById("post-game")!;
    postScreen.style.display = "none";
    postScreen.classList.remove("clickable"); // Reset for next time
    // Reload the page to restart the game
    window.location.reload();
  };

  // Make game intro clickable after initial fade-in
  const gameIntro = document.getElementById("game-intro")!;
  setTimeout(() => {
    gameIntro.classList.add("clickable");
  }, 800);
};
